import router from '../router'
import axios from 'axios'
axios.defaults.withCredentials = true
export default {
    state:{
        baseUrl:process.env.API_URL,
        email_setting:{},
        token:'',
        user_settings:{},
        company_settings:{}
    },
    getters:{
        email_setting:(state)=>{
            return state.email_setting
        },
        token:(state)=>{
            return state.token
        },
        user_settings:(state)=>{
            return state.user_settings
        },
        company_settings:(state)=>{
            return state.company_settings
        },
        security_settings:(state)=>{
            return state.security_settings
        }

    },
    mutations:{
        email_setting(state,setting){
            state.email_setting = setting
        },
        token(state,token){
            state.token= token
        },
        user_settings(state,settings){
            state.user_settings = settings
        },
        company_settings(state,settings){
            state.company_settings = settings
        },
        security_settings(state,settings){
            state.security_settings = settings
        }

    },
    actions:{
        getUserSettings({commit,state}){

            return new Promise((resolve, reject) => {
                
                axios.post(`${state.baseUrl}/getUserSettings`)
                .then(response => {
                    console.log("response")
                    console.log(response.data.token)
                    if(response.data.status.code=='0'){
                        commit('user_settings',response.data.content.userSetting)
                        
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                    
                })
                .catch(e => {
                    console.log(e)
                    reject()
                })
            })
        },
        updateUserSettings({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateUserSettings`,form)
                .then(response => {
                    console.log("updateUserSettings-response.data")
                    console.log(response)
                    resolve(response)
                })
                .catch(e => {
                    console.log(e)
                    reject(false)
                })
            })
        },
        changePassword({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/changePassword`,form)
                .then(response => {
                    console.log("changePassword-response.data")
                    console.log(response)
                    resolve(response)
                })
                .catch(e => {
                    console.log(e)
                    reject(false)
                })
            })
        },
        getCompanySettings({commit,state}){

            return new Promise((resolve, reject) => {
                
                axios.post(`${state.baseUrl}/getCompanySettings`)
                .then(response => {
                    console.log("response")
                    console.log(response.data.token)
                    if(response.data.status.code=='0'){
                        commit('company_settings',response.data.content.companySetting)
                        
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                    
                })
                .catch(e => {
                    console.log(e)
                    reject()
                })
            })
        },
        updateCompanySettings({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateCompanySettings`,form)
                .then(response => {
                    console.log("updateCompanySettings-response.data")
                    console.log(response)
                    resolve(response)
                })
                .catch(e => {
                    console.log(e)
                    reject(false)
                })
            })
        },
        upsertEmailSetting({state},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/upsertEmailSetting`,form)
                .then(response => {
                    console.log("upsertEmailSettings-response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        
                        resolve(true)
                    }else{
                        
                        reject(false)
                    }
                    
                })
                .catch(e => {
                    console.log(e)
                    reject()
                })
            })
        },
        getEmailSetting({commit,state}){

            return new Promise((resolve, reject) => {
                
                axios.post(`${state.baseUrl}/getEmailSetting`)
                .then(response => {
                    console.log("response")
                    console.log(response.data.token)
                    if(response.data.status.code=='0'){
                        commit('email_setting',response.data.content.email_setting)
                        commit('token',response.data.token)
                        let obj = {}
                        obj['email_setting']= response.data.content.email_setting
                        obj['token'] = response.data.token
                        obj['result'] = true
                        resolve(obj)
                    }
                    else if(response.data.status.code=='2054'){
                        router.push({ path: 'settings',  query: { paymentStatus: 'userManagement' } })
                    }
                    else{
                        reject(false)
                    }
                    
                })
                .catch(e => {
                    console.log(e)
                })
            })
        },
        exportUsers({state}){
            axios({
                method:'POST',
                url:'/exportUsers',
                baseURL: state.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                console.log(res)
                if(res.data.status.code==0 && res.data.content.link){
                    console.log(res.data.content.link)
                    window.open(res.data.content.link,'_blank')
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        instructBackupRestoration({state},form){

            return new Promise((resolve, reject) => {
                
                axios.post(`${state.baseUrl}/instructBackupRestoration`,form)
                .then(response => {
                    console.log("instructBackupRestoration response")
                    console.log(response)
                    resolve(response)
                })
                .catch(e => {
                    console.log(e)
                    reject(false)
                })
            })
        },
        getDLLinkForCompanyBackups({state},form){

            return new Promise((resolve, reject) => {
                
                axios.post(`${state.baseUrl}/getDLLinkForCompanyBackups`,form)
                .then(response => {
                    console.log("getDLLinkForCompanyBackups response")
                    console.log(response)
                    resolve(response)
                })
                .catch(e => {
                    console.log(e)
                    reject(false)
                })
            })
        },
        getEventLogs({state,commit},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getEventLogs`,form)
                .then(response => {
                    console.log("getEventLogs action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
        },
        create({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/create`,form)
                .then(response => {
                    console.log("create workflow action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        
                        resolve(response.data)
                    }else{
                        resolve(false)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
        },
   
    }
}